import { render, staticRenderFns } from "./Restaurants.vue?vue&type=template&id=84790ca2&scoped=true&"
import script from "./Restaurants.vue?vue&type=script&lang=js&"
export * from "./Restaurants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84790ca2",
  null
  
)

export default component.exports